import React from 'react'
import './navbar.css'
import { Link } from 'react-router-dom'
import {motion} from 'framer-motion'

function Navbar() {
  return (
    <div >
                <nav className="navbar navbar-expand-lg fixed-top navbar-dark bg-black">
        <div className="container-fluid">
        <Link className="navbar-brand fs-2" to="/">
        <motion.img src="images/logo.png" width="150px" height="40px" alt="logo" style={{paddingLeft:'25px'}} initial={{y:'-20vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}/>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#toggleMobileMenu" aria-controls="toggleMobileMenu" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="toggleMobileMenu" style={{paddingRight:'25px'}}>
        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
            <motion.a className="nav-link active" aria-current="page" style={{fontSize:'20px'}} href="/" initial={{y:'-20vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>Home</motion.a>
            </li>
            <li className="nav-item">
            <motion.a className="nav-link" style={{fontSize:'20px'}} href="/Events" initial={{y:'-20vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>Events</motion.a>
            </li>
            <li className="nav-item">
            <motion.a className="nav-link" style={{fontSize:'20px'}} href="/Sponsers" initial={{y:'-20vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>Sponsors</motion.a>
            </li>
            <li className="nav-item">
            <motion.a className="nav-link" style={{fontSize:'20px'}} href="/Contactus" initial={{y:'-20vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>Contact Us</motion.a>
            </li>
            
        </ul>
        
        </div>
    </div>
    </nav>
        </div>
  )
}

export default Navbar